import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  canAccess: boolean;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  canAccess,
  children,
}) => {
  return canAccess ? <>{children}</> : <Navigate to="/Access-Denied" replace />;
};

export default ProtectedRoute;
